import React from "react";
import SVGIcon, { IconProps } from "ui/SVGIcon";

const path =
  "M8.00065 1.3335C4.32065 1.3335 1.33398 4.32016 1.33398 8.00016C1.33398 11.6802 4.32065 14.6668 8.00065 14.6668C11.6807 14.6668 14.6673 11.6802 14.6673 8.00016C14.6673 4.32016 11.6807 1.3335 8.00065 1.3335ZM8.00065 13.3335C5.06065 13.3335 2.66732 10.9402 2.66732 8.00016C2.66732 5.06016 5.06065 2.66683 8.00065 2.66683C10.9407 2.66683 13.334 5.06016 13.334 8.00016C13.334 10.9402 10.9407 13.3335 8.00065 13.3335ZM6.66732 9.44683L10.5873 5.52683C10.8473 5.26683 11.274 5.26683 11.534 5.52683C11.794 5.78683 11.794 6.20683 11.534 6.46683L7.14065 10.8602C6.88065 11.1202 6.46065 11.1202 6.20065 10.8602L4.47398 9.1335C4.21398 8.8735 4.21398 8.4535 4.47398 8.1935C4.59854 8.06866 4.76764 7.99851 4.94398 7.99851C5.12033 7.99851 5.28943 8.06866 5.41398 8.1935L6.66732 9.44683Z";

export default function CheckMarkCircle(props: IconProps) {
  return (
    <SVGIcon
      path={path}
      fill-rule="evenodd"
      clip-rule="evenodd"
      viewBox="0 0 16 16"
      {...props}
    />
  );
}
